import { z } from 'zod';

export const step1Schema = z.object({
  estimationType: z.enum(['prix', 'loyer'], {
    required_error: 'Veuillez sélectionner un type d\'estimation',
  }),
});

export const step2Schema = z.object({
  propertyType: z.enum(['bureaux', 'commerce', 'local-activite', 'industriel'], {
    required_error: 'Veuillez sélectionner un type de bien',
  }),
});

const step3BaseSchema = z.object({
  address: z.string({
    required_error: 'Champ obligatoire',
    invalid_type_error: 'Champ obligatoire',
  }).min(1, 'Champ obligatoire'),
  surface: z.number({
    required_error: 'Champ obligatoire',
    invalid_type_error: 'Champ obligatoire',
  }).min(5, 'La surface doit être supérieure à 5 m²').optional(),
  surfaceRdc: z.number({
    required_error: 'Champ obligatoire',
    invalid_type_error: 'Champ obligatoire',
  }).min(5, 'La surface doit être supérieure à 5 m²').optional(),
  surfaceSousSol: z.number({
    required_error: 'Champ obligatoire',
    invalid_type_error: 'Champ obligatoire',
  }).min(0, 'La surface doit être positive ou zéro').optional(),
});

export const step3Schema = step3BaseSchema.refine(
  (data) => {
    // Either surface OR surfaceRdc must be provided
    return (data.surface !== undefined && data.surface !== null) || 
           (data.surfaceRdc !== undefined && data.surfaceRdc !== null);
  },
  {
    message: 'Champ obligatoire',
    path: ['surface'],
  }
);

export const step4Schema = z.object({
  lastName: z.string().min(2, 'Le nom doit contenir au moins 2 caractères'),
  firstName: z.string().min(2, 'Le prénom doit contenir au moins 2 caractères'),
  company: z.string().optional(),
  email: z.string().email('Veuillez entrer une adresse email valide'),
  phone: z.string().optional().refine(
    (val) => !val || /^[+]?[\d\s\-().]{8,20}$/.test(val),
    { message: 'Veuillez entrer un numéro de téléphone valide' }
  ),
});

/**
 * Creates a step4 schema with phone field required or optional based on configuration.
 * @param withPhone - If true, phone field is required; otherwise optional
 */
export const createStep4Schema = (withPhone: boolean) => {
  if (withPhone) {
    return z.object({
      lastName: z.string().min(2, 'Le nom doit contenir au moins 2 caractères'),
      firstName: z.string().min(2, 'Le prénom doit contenir au moins 2 caractères'),
      company: z.string().optional(),
      email: z.string().email('Veuillez entrer une adresse email valide'),
      phone: z.string()
        .min(1, 'Le téléphone est obligatoire')
        .refine(
          (val) => /^[+]?[\d\s\-().]{8,20}$/.test(val),
          { message: 'Veuillez entrer un numéro de téléphone valide' }
        ),
    });
  }
  return step4Schema;
};

export const fullFormSchema = z.object({
  estimationType: step1Schema.shape.estimationType,
  propertyType: step2Schema.shape.propertyType,
  address: step3BaseSchema.shape.address,
  surface: step3BaseSchema.shape.surface,
  surfaceRdc: step3BaseSchema.shape.surfaceRdc,
  surfaceSousSol: step3BaseSchema.shape.surfaceSousSol,
  user: z.object({
    lastName: step4Schema.shape.lastName,
    firstName: step4Schema.shape.firstName,
    company: step4Schema.shape.company,
    email: step4Schema.shape.email,
    phone: step4Schema.shape.phone,
  }),
});
